import React from 'react';

export default function AppFooter() {
  return (
    <footer align="left" className="mt-4">
      <p>Ivan on Tech Academy Bootcamp 2020</p>
    </footer>
  );
}
